import { createSelector } from 'reselect';
import { mapWithDefault, toJs } from '../../../utils/dataMapper';

const selectStepOther = (state) => state.get('stepOther');

const makeSelectStepOther = () => createSelector(
  selectStepOther,
  (stepOtherState) => ({
    isThereAnyThingElseYouWouldLikeToClaimFor: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'isThereAnyThingElseYouWouldLikeToClaimFor']), ''),
    areYouClaimingForPersonalLiability: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'areYouClaimingForPersonalLiability']), ''),
    areYouClaimingForGolfPackOptionalCover: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'areYouClaimingForGolfPackOptionalCover']), ''),
    areYouClaimingForBicyclePackOptionalCover: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'areYouClaimingForBicyclePackOptionalCover']), ''),
    areYouClaimingForAccidentalDeathAndDismemberment: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'areYouClaimingForAccidentalDeathAndDismemberment']), ''),
    areYouClaimingForRepatriationExpenses: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'areYouClaimingForRepatriationExpenses']), ''),
    areYouClaimingForBurialExpenses: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'areYouClaimingForBurialExpenses']), ''),
    personalLiabilitiesClaimDetail: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'personalLiabilitiesClaimDetail'])), ''),
    golfPackOptionalClaimDetail: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'golfPackOptionalClaimDetail'])), ''),
    bicyclePackOptionalClaimDetail: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'bicyclePackOptionalClaimDetail'])), ''),
    personalLiabilitiesExpensesClaimed: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'personalLiabilitiesExpensesClaimed'])), ''),
    golfPackOptionalExpensesClaimed: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'golfPackOptionalExpensesClaimed'])), ''),
    bicyclePackOptionalExpensesClaimed: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'bicyclePackOptionalExpensesClaimed'])), ''),
    anythingElse: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'anythingElse'])), ''),
    anythingElseExpensesClaimed: mapWithDefault(stepOtherState, () => toJs(stepOtherState.getIn(['form', 'anythingElseExpensesClaimed'])), ''),
    enableTime: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'enableTime']), null),
    // AD&D
    nameOfDeceased: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'nameOfDeceased']),
      ''
    ),

    dateOfInjury: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'dateOfInjury']),
      ''
    ),
    theClaimIsBeingMadeUnder: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'theClaimIsBeingMadeUnder']),
      ''
    ),
    placeWhereAccidentHappened: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'placeWhereAccidentHappened']),
      ''
    ),
    describeWhereTheAccidentOccurred: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'describeWhereTheAccidentOccurred']),
      ''
    ),
    describeHowTheAccidentOccurred: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'describeHowTheAccidentOccurred']),
      ''
    ),
    checkNameOfDeceased: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'checkNameOfDeceased']),
      ''
    ),
    // RepatriationExpenses
    assistance: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'assistance']),
      ''
    ),

    dateApproved: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'dateApproved']),
      ''
    ),

    causeOfDeath: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'causeOfDeath']),
      ''
    ),

    dateOfDeath: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'dateOfDeath']),
      ''
    ),

    stateOfDeath: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'stateOfDeath']),
      ''
    ),

    countryOfDeath: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'countryOfDeath']),
      ''
    ),

    wasTheMemberHospitalized: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'wasTheMemberHospitalized']),
      ''
    ),

    fromDate: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'fromDate']),
      ''
    ),

    toDate: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'toDate']),
      ''
    ),

    nameOfFuneralServiceProvider: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'nameOfFuneralServiceProvider']),
      ''
    ),

    costOfLocalBurial: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'costOfLocalBurial']),
      ''
    ),

    invoice: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'invoice']),
      ''
    ),

    amountClaimed: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'amountClaimed']),
      ''
    ),

    amountClaimedCurrency: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'amountClaimedCurrency']),
      ''
    ),

    costOfLocalBurialCurrency: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'costOfLocalBurialCurrency']),
      ''
    ),

    familyMemberProvidingInformation: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'familyMemberProvidingInformation']),
      ''
    ),

    relationshipToMember: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'relationshipToMember']),
      ''
    ),

    address: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'address']),
      ''
    ),

    cityOrTown: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'cityOrTown']),
      ''
    ),

    country: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'country']),
      ''
    ),

    postalCode: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'postalCode']),
      ''
    ),

    phoneNumber: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'phoneNumber']),
      ''
    ),
    // BurialExpenses
    assistanceForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'assistanceForBurial']), ''),
    dateApprovedForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'dateApprovedForBurial']), ''),
    causeOfDeathForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'causeOfDeathForBurial']), ''),
    dateOfDeathForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'dateOfDeathForBurial']), ''),
    stateOfDeathForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'stateOfDeathForBurial']), ''),
    countryOfDeathForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'countryOfDeathForBurial']), ''),
    wasTheMemberHospitalizedForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'wasTheMemberHospitalizedForBurial']), ''),
    fromDateForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'fromDateForBurial']), ''),
    toDateForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'toDateForBurial']), ''),
    nameOfFuneralServiceProviderForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'nameOfFuneralServiceProviderForBurial']), ''),
    costOfLocalBurialForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'costOfLocalBurialForBurial']), ''),
    invoiceForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'invoiceForBurial']), ''),
    amountClaimedForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'amountClaimedForBurial']), ''),
    costOfLocalBurialCurrencyForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'costOfLocalBurialCurrencyForBurial']), ''),
    amountClaimedCurrencyForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'amountClaimedCurrencyForBurial']), ''),
    familyMemberProvidingInformationForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'familyMemberProvidingInformationForBurial']), ''),
    relationshipToMemberForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'relationshipToMemberForBurial']), ''),
    addressForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'addressForBurial']), ''),
    cityOrTownForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'cityOrTownForBurial']), ''),
    countryForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'countryForBurial']), ''),
    postalCodeForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'postalCodeForBurial']), ''),
    phoneNumberForBurial: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'phoneNumberForBurial']), ''),
    // Other SCTI
    whatExpensesAreYouClaimingFor: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'whatExpensesAreYouClaimingFor']),
      ''
    ),
    whatAreYourExpensesRelatedTo: mapWithDefault(
      stepOtherState,
      () => stepOtherState.getIn(['form', 'whatAreYourExpensesRelatedTo']),
      ''
    ),
    infoPersonalLiabilityItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'infoPersonalLiabilityItems']) && stepOtherState.getIn(['form', 'infoPersonalLiabilityItems']).toJS(), ''),
    infoPersonalAccidentItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'infoPersonalAccidentItems']) && stepOtherState.getIn(['form', 'infoPersonalAccidentItems']).toJS(), ''),
    infoLossOfIncomeItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'infoLossOfIncomeItems']) && stepOtherState.getIn(['form', 'infoLossOfIncomeItems']).toJS(), ''),
    infoTotalPermanentDisablementItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'infoTotalPermanentDisablementItems']) && stepOtherState.getIn(['form', 'infoTotalPermanentDisablementItems']).toJS(), ''),
    infoLossOfLifeItems: mapWithDefault(stepOtherState, () => stepOtherState.getIn(['form', 'infoLossOfLifeItems']) && stepOtherState.getIn(['form', 'infoLossOfLifeItems']).toJS(), ''),
  })
);

const makeSelectStepOtherErrors = () =>
  createSelector(selectStepOther, (state) => state.get('errors'));

export {
  makeSelectStepOther,
  makeSelectStepOtherErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/selectors.js